import { render, staticRenderFns } from "./indexTwo.vue?vue&type=template&id=13ec7fb4&"
import script from "./indexTwo.vue?vue&type=script&lang=js&"
export * from "./indexTwo.vue?vue&type=script&lang=js&"
import style0 from "./indexTwo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports